import { Flex } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis-atomic';
import { COLORS } from '@lemonade-hq/tokens';
import styled, { css, type CSSProperties } from 'styled-components';
import { SectionParagraph, SectionTitle } from '../shared/Content';

interface SectionProps {
  darkBackground: boolean;
  contain: CSSProperties['contain'];
}

export const Section = styled(Flex).attrs({
  as: 'section',
})<SectionProps>`
  flex-direction: column;
  align-items: center;
  background-color: ${({ darkBackground }: SectionProps) => (darkBackground ? COLORS.cloud : COLORS.white)};
  ${({ contain }) =>
    contain != null &&
    css`
      contain: ${contain};
    `}
`;

export const GBSectionTitle = styled(SectionTitle)`
  font-size: 2.4rem;
  line-height: 145%;
  text-align: left;
  padding: 0;
  width: 100%;
  ${MEDIA_QUERIES.tabletAndDesktop`
        font-size: 4rem;
        line-height: 58px;
        text-align: center;
  `}
`;

export const GBSectionParagraph = styled(SectionParagraph)`
  text-align: left;
  ${MEDIA_QUERIES.tabletAndDesktop`
        text-align: center;
  `}
`;

export const ImpactItem = styled(Flex)``;

export const ImpactSectionContainer = styled(Flex)`
  ${MEDIA_QUERIES.tabletAndDesktop`
    gap: 50px 70px;
  `}
`;

export const ImpactItemInfo = styled(Flex)`
  flex-direction: column;
  align-items: center;
`;

export const ImpactItemTitle = styled(Flex)`
  justify-content: center;
  width: 100%;
  margin-bottom: 4px;

  ${MEDIA_QUERIES.tabletAndDesktop`
    margin-top: 24px;
  `};
`;
export const ImpactItemImpactTitle = styled(Flex)`
  justify-content: center;
  width: 100%;
`;

export const ImpactItemDescription = styled(Flex)`
  justify-content: center;
  text-wrap: balance;
`;
